import styled from 'styled-components';

export const ContainerDelivery = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid var(--Takeat-Colors-Neutrals-Grey-03, #c6c6c6);
  background: ${(props) => props.color};

  /* 03 */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
`;
